export const ConnectingState = Object.freeze({
  OFFLINE: 1, // button shows green
  CONNECTING: 2, // button shows grey
  ONLINE: 3, // button shows red
});

export const TaskStatus = Object.freeze({
  LAUNCHING: 'launching',
  LOGIN_FAILED: 'login-failed',
  WAIT_FOR_INPUT: 'wait-for-input',
  LOGIN_SUCCEEDED: 'login-succeeded',
  PLAYING: 'playing',
  NEW_ACCOUNT: 'new-account',
});

export const GameOptions = Object.freeze({
  TSUM: 'tsum',
  COOKIE_KINGDOM: 'cookieKingdom',
  MLB9I: 'mlb9i',
});
